// src/geoTracker.js

let watchId = null;

/**
 * Ensure browser geolocation permission is available.
 * On web, we can't force permission prompts except by calling getCurrentPosition.
 */
export async function ensurePermissions() {
  if (!("geolocation" in navigator)) {
    throw new Error("Geolocation not supported on this device/browser.");
  }

  // Trigger permission prompt if needed
  await new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      () => resolve(true),
      (err) => reject(new Error(err?.message || "Location permission denied.")),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  });

  return true;
}

/**
 * Start tracking the worker for a shift.
 * Calls onLocation({ latitude, longitude, accuracy })
 */
export async function startTrackingForShift({ shiftId, onLocation }) {
  if (!shiftId) throw new Error("Missing shiftId");
  if (typeof onLocation !== "function") throw new Error("Missing onLocation callback");

  if (!("geolocation" in navigator)) {
    throw new Error("Geolocation not supported.");
  }

  // Stop any existing watcher first (prevents duplicates + flicker)
  stopTracking();

  watchId = navigator.geolocation.watchPosition(
    (pos) => {
      try {
        const { latitude, longitude, accuracy } = pos.coords || {};
        onLocation({ latitude, longitude, accuracy });
      } catch (e) {
        console.error("onLocation handler failed:", e);
      }
    },
    (err) => {
      console.error("watchPosition error:", err);
    },
    {
      enableHighAccuracy: true,
      maximumAge: 5000,
      timeout: 20000,
    }
  );

  return watchId;
}

export async function stopTracking() {
  if (watchId != null && "geolocation" in navigator) {
    navigator.geolocation.clearWatch(watchId);
  }
  watchId = null;
}